import './AboutPage.css'

function AboutPage() {
  return (
    <div className="about-page">
      <div className="about-hero">
        <h1>About Hilton Analytica</h1>
      </div>
      <div className="about-container">

        <section className="about-section-block">
          <h2>Our Mission</h2>
          <p>
            Hilton Analytica is dedicated to providing <strong>industry-leading purity analysis</strong> for{' '}
            <strong>research-use-only peptides</strong>. Since 2023, we have established the largest publicly
            searchable COA repository in peptide testing, serving vendors and researchers across the globe.
          </p>
        </section>

        <section className="about-section-block">
          <h2>Complete Verification, Every Time</h2>
          <p>
            Every Certificate of Analysis we issue includes both <strong>HPLC purity</strong> and{' '}
            <strong>LC-MS identity confirmation</strong> — never one without the other. A purity
            value without identity verification is an incomplete result, and we believe our
            clients deserve the complete picture.
          </p>
        </section>

        <section className="about-section-block">
          <h2>Rapid Results</h2>
          <p>
            Average results delivered in <strong>5-10 days</strong>. While
            competitors take 5 to 11 days, your COA is ready before your next shipment goes out.
            Speed without compromise.
          </p>
        </section>

        <section className="about-section-block">
          <h2>Completely Independent</h2>
          <p>
            No vendor affiliations. No supplier relationships. No conflicts of interest. We test
            for the research community — and that independence is what gives our results
            their authority. Over 45,000 public COAs available for independent verification.
          </p>
        </section>

        <section className="about-section-block">
          <h2>Quality Standards</h2>
          <p>
            All testing is performed following <strong>Good Laboratory Practice (GLP)</strong>{' '}
            quality standard principles and is compliant with <strong>ISO 9001</strong> quality
            management principles. Results are for research purposes only.
          </p>
        </section>

        <section className="about-section-block about-cta">
          <h2>Ready to Get Started?</h2>
          <p>
            <a href="/request">Submit samples for testing</a> or{' '}
            <a href="/search">look up a Certificate of Analysis</a>.
          </p>
        </section>
      </div>
    </div>
  )
}

export default AboutPage
